import { Component, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppTopbar } from './app.topbar';
import { AppSidebar } from './app.sidebar';
import { AppFooter } from './app.footer';
import { LayoutService } from '@/app/core/auth-layout/service/layout.service';
import { AuthService } from '../../../features/authentication/services/auth.service';


@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [CommonModule, AppTopbar, AppSidebar, RouterModule, AppFooter, ],
    template: `
    <div class="layout-wrapper" [ngClass]="containerClass()">


        <app-topbar></app-topbar>
        <app-sidebar></app-sidebar>

        <div class="layout-main-container">
            <div class="layout-main">
                <router-outlet></router-outlet>
            </div>
            <app-footer></app-footer>
        </div>

        <div class="layout-mask"></div>
    </div>
    `,
    styles: [
        `
       .layout-wrapper {
                height: 100vh;
                min-height: 0;
                overflow: hidden;
            }

            .layout-main-container {
                display: flex;
                flex-direction: column;
                min-height: 0;
                height: calc(100vh - 4rem);
                overflow: hidden;
            }

            .layout-main {
                flex: 1 1 auto;
                min-height: 0;
                overflow: auto;
            }

            app-footer {
                flex: 0 0 auto;
            }
            `],
})
export class AppLayout {
    layoutService = inject(LayoutService);
    readonly authService = inject(AuthService);

    readonly authenticated =
        this.authService.authenticatedSignal;

    constructor() {
        effect(() => {
            const state = this.layoutService.layoutState();
            if (state.mobileMenuActive) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.classList.remove('blocked-scroll');
            }
        });
    }

    containerClass = computed(() => {
        const config = this.layoutService.layoutConfig();
        const state = this.layoutService.layoutState();
        return {
            'layout-overlay': config.menuMode === 'overlay',
            'layout-static': config.menuMode === 'static',
            'layout-static-inactive': state.staticMenuDesktopInactive && config.menuMode === 'static',
            'layout-overlay-active': state.overlayMenuActive,
            'layout-mobile-active': state.mobileMenuActive,
            'layout-no-sidebar': this.authenticated() !== true
        };
    })
}
